import { Mic } from "react-feather";
import { Input } from "reactstrap";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { Href, NameAndPhoneNumber } from "../../../../../Constants/Constants";
import { P } from "../../../../../AbstractElements";
import { Fragment } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { ContactList } from "./ContactList";

export const ContactTabPane = () => {
  return (
    <Fragment>
      <div className="common-space">
        <P>{`Contacts`}</P>
        <div className="header-top">
          <Link className="btn badge-light-primary f-w-500" to={Href}>
            <i className="fa fa-plus" />
          </Link>
        </div>
      </div>
      <div className="search-contacts">
        <Input type="text" placeholder={NameAndPhoneNumber} />
        <SvgIcon iconId="stroke-search" />
        <Mic className="mic-search" />
      </div>
      <ContactList/>
    </Fragment>
  );
};
